import http from "@/utils/request";
export default {
  send: (data) => http.post("/mos/chat/send", data),
  searchPage: (data) => http.post("/mos/chat/searchPage", data),
  update: (data) => http.post("/mos/chat/update", data),
  delete: (data) => http.post("/mos/chat/delete", data),
  searchRecordList: (data) => http.post("/mos/chat/searchRecordList", data),
  saveRecordFeedback: (data) => http.post("/mos/chat/saveRecordFeedback", data),
  searchCvFilePage: (data) => http.post("/mos/chat/searchCvFilePage", data),
  searchFileListByChat: (data) => http.post("/mos/chat/searchFileListByChat", data),
  searchFileListByRecord: (data) => http.post("/mos/chat/searchFileListByRecord", data),
  getFileByGuid: (data) => http.post("/mos/chat/getFileByGuid", data),
  searchFilePage: (data) => http.post("/mos/chat/searchFilePage", data),
  saveFileMyFlag: (data) => http.post("/mos/chat/saveFileMyFlag", data),
  generateFile: (data) => http.post("/mos/chat/generateFile", data),
  generatePdf: (data) => http.post("/mos/chat/generatePdf", data),
};